// @mui
import { arSD, enUS, frFR, viVN, zhCN } from '@mui/material/locale';
// routes
import { PATH_DASHBOARD } from './routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = process.env.REACT_APP_HOST_API;
// Deactivate Console for prod:
if (process.env.REACT_APP_IS_PRODUCTION === 'true') {
  console.log = function () { };
}


export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: process.env.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

export const MAPBOX_API = process.env.REACT_APP_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
// /dashboard is the unified home page (no /dashboard/app subpath anymore).
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.root;

// PROGRAM
// ----------------------------------------------------------------------

export const ROL_USER = {
  ADMIN: 'ADMIN',
  NORMAL: 'NORMAL',
  THERAPIST: 'THERAPIST',
  HOLISTIQUMUSER: 'HOLISTIQUMUSER',
}

export const IMG_LOCATION = {
  cover: 'HI',
  profile: 'PR',
  gallery: 'EP',
}

// `name` is a URL-substring matched by MemershipGuard (pathname.includes).
// `perk` is the backend perk code. `label` is the human-readable product name
// used in display (e.g. MyMemberships). `path` is the redirect target after
// successful payment.
//
// Tarot has two distinct perks (TR_SUB = monthly sub, TR = one-time 3-card),
// so each gets its own URL-specific entry. The hub at /dashboard/mystic/tarot
// is intentionally NOT listed so it stays open for upsell tiles to render.
export const MEMBERSHIPS = [
  { name: 'tarot/daily', perk: 'TR_SUB', label: 'Tarot diario', path: PATH_DASHBOARD.mystic.tarot.daily },
  { name: 'tarot/ask', perk: 'TR', label: 'Tarot · Lectura profunda', path: PATH_DASHBOARD.mystic.tarot.ask },
  { name: 'bach-flowers', perk: 'BF', label: 'Flores de Bach', path: PATH_DASHBOARD.tools.bachflowers.root },
  { name: 'astralchart', perk: 'AC', label: 'Carta Astral', path: PATH_DASHBOARD.tools.astralchart.root },
  { name: 'numerology', perk: 'NU', label: 'Numerología', path: PATH_DASHBOARD.tools.numerology.root },
  { name: 'biopairs', perk: 'BP', label: 'Biopares', path: PATH_DASHBOARD.biopairs.root },
  { name: 'sinastria', perk: 'SI', label: 'Sinastría', path: PATH_DASHBOARD.tools.sinastria.root },
]

// Productos por crédito/lectura (NO van en MEMBERSHIPS: MemershipGuard
// gatearía sus páginas free por substring de URL). Solo se usan para
// resolver label/destino tras un pago exitoso (Payment.js).
export const CREDIT_PRODUCTS = [
  { perk: 'SU', label: 'Oráculo de Sueños', path: PATH_DASHBOARD.tools.suenos.root },
  { perk: 'RN', label: 'Runas · Tirada de las Nornas', path: PATH_DASHBOARD.tools.runas.root },
  { perk: 'CN', label: 'Carta Nahual', path: '/tools/carta-nahual' },
]

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const defaultSettings = {
  themeMode: 'light',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'horizontal',
  themeColorPresets: 'default',
  themeStretch: false,
};

// MULTI LANGUAGES
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/assets/icons/flags/ic_flag_en.svg',
  },
  {
    label: 'French',
    value: 'fr',
    systemValue: frFR,
    icon: '/assets/icons/flags/ic_flag_fr.svg',
  },
  {
    label: 'Vietnamese',
    value: 'vn',
    systemValue: viVN,
    icon: '/assets/icons/flags/ic_flag_vn.svg',
  },
  {
    label: 'Chinese',
    value: 'cn',
    systemValue: zhCN,
    icon: '/assets/icons/flags/ic_flag_cn.svg',
  },
  {
    label: 'Arabic (Sudan)',
    value: 'ar',
    systemValue: arSD,
    icon: '/assets/icons/flags/ic_flag_sa.svg',
  },
];

export const defaultLang = allLangs[0]; // English

Object.freeze(ROL_USER, IMG_LOCATION, MEMBERSHIPS);